module.exports = __webpack_public_path__ + "img/slide-15_medium.9b99640f.png";